const projects = (axios) => {
  return {

    /**
         * @param params
         * @method get
         * @api /api/projects/get_all?page=4&ppage=4
         */
    get (params) {
      return axios.get(`/projects/get_all?page=${params.page}&ppage=${params.perPage}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method get
         * @api /api/projects/get_tasks/{id}?page=1&ppage=1
         */
    getProjectTask (params) {
      return axios.get(`/projects/get_tasks/${params.id}?page=${params.page}&ppage=${params.perPage}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/project/get/{id}
         */
    getProject (id) {
      return axios.get(`/project/get/${id}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/upload_attachment/{id}
         */
    uploadFile (params) {
      return axios.post(`/project/upload_attachment/${params.id}`, params.file)
        .then((response) => response);
    },

    /**
         * @param path
         * @method post
         * @api /api/project/remove_attachment/{path file}
         */
    removeFiles (path) {
      return axios.post(`/project/remove_attachment/${path}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/projects/update/{id}
         */
    update (params) {
      return axios.post(`/projects/update/${params.id}`, params.params)
        .then((response) => response);
    },

    createProject: {

      /**
             * Method for gettings params
             *
             * @api /api/createproject/getparams
             */
      getParams () {
        return axios.get('/createproject/getparams')
          .then((response) => response);
      },

      /**
             * Method for gettings params
             *
             * @param {Object} params
             * @api /api/createproject
             */
      create (params) {
        return axios.post('/createproject', params)
          .then((response) => response);
      },

    },

    /**
         * Method for download file on link
         *
         * @param {String} url
         */
    downloadFile (url) {
      return axios.get(`${url}`)
        .then((response) => response);
    },

  };
};

export default projects;
